import { render } from "./index.vue?vue&type=template&id=d52ad0c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d52ad0c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d52ad0c2"

export default script